import { Component, OnInit, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth-service.service';
import { RouteDataService } from '../../services/routedata.services';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnChanges {
  username: string;
  password: string;
  errorMessage: string;
  returnUrl: string;

  constructor(private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private routeDataService: RouteDataService) {
  }

  ngOnInit(): void {
    this.auth.logout();
    this.routeDataService.clear();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || "/request";
  }

  ngOnChanges() {
    this.auth.logout();
    this.routeDataService.clear();
  }

  onLogin() {
    this.auth.checkAuthentication(this.username, this.password).subscribe(
      token => {
        this.router.navigateByUrl(this.returnUrl);
      },
      err => {
        this.errorMessage = "Check your S1 username & password!";
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts